import '.d{display:flex;}.ssr-plugin'
import '.r{align-items:center;}.ssr-plugin'
import '.ad{justify-content:center;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.aq{background-color:var(--palette-beige-100);}.ssr-plugin'
import '.ew{min-height:calc(100vh - 12rem);}.ssr-plugin'
import '.a8{align-items:stretch;}.ssr-plugin'
import '.ex{margin-top:2rem;}.ssr-plugin'
import '.a7{margin-bottom:5rem;}.ssr-plugin'
import '.ai{max-width:77.5rem;}.ssr-plugin'
import { ReactNode } from 'react'
import { styled } from 'inlines'
import { Property } from 'csstype'
import useMediaQuery from '@app/util/useMediaQuery'
import { DashboardNavBar } from '@app/components/blocks/navbar/dashboard/DashboardNavBar'
import { ClientOnly } from '@based/sdk'
import { PageSeo } from '@app/components/core/seo/PageSeo'
import { useTranslations } from '@i18n/useLanguage'

export const DashboardPageLayout = ({
  gap = '1rem',
  children,
}: {
  gap?: Property.Gap<(string & {}) | 0>
  children: ReactNode
}) => {
  const isMobile = useMediaQuery()
  const t = useTranslations().app.dashboardPage
  return (
    <>
      <PageSeo pageTitle={t.title} noindex />
      <ClientOnly>
      <div className="d r ad e aq"
      >
        <DashboardNavBar />
        <div className="ew d e a8 ex a7 ai"
          style={{
            gap: gap,
            width: isMobile ? '100%' : '85%', // 12rem is padding + navbar height
            paddingInline: isMobile ? '1rem' : 0,}}
        >
          {children}
        </div>
      </div>
      </ClientOnly>
    </>
  )
}
